// @flow

import { serialize } from 'object-to-formdata';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import type { ticketType } from '../../types';
import { hpfetch, hpfetchWithoutContentType } from '../util';

export const getSingle = (
  transactionId: number,
  id: number,
): Promise<wrappedApiResponseType<ticketType>> =>
  hpfetch(`purchases/${transactionId}/tickets/${id}/`);

export const getMany = (
  transactionId: number,
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<ticketType> =>
  hpfetch(
    `purchases/${transactionId}/tickets/?limit=${limit}&offset=${offset}`,
  );

export const update = (
  transactionId: number,
  id: number,
  fields: any,
  image: ?{ blob: any, filename: string },
) => {
  const formData = serialize(fields);
  if (image) {
    formData.append('image', image.blob, image.filename);
  }

  return hpfetchWithoutContentType(
    `purchases/${transactionId}/tickets/${id}/`,
    {
      method: 'PATCH',
      body: formData,
    },
  );
};

export const create = (
  transactionId: number,
  fields: any,
  image: ?{ blob: any, filename: string },
): Promise<wrappedApiResponseType<ticketType>> => {
  const formData = serialize(fields);
  if (image) {
    formData.append('image', image.blob, image.filename);
  }

  return hpfetchWithoutContentType(`purchases/${transactionId}/tickets/`, {
    method: 'POST',
    body: formData,
  });
};
